import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Card, CardContent, Typography, Collapse, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { formatDateTime } from '../../../../../../services/functions';

const obozyFieldsToFilter = [
  'Pokój', 'Moduł', 'Termin', 'Sezon', 'Rodzaj wariantu', 'Transfer',
  'Termin Do', 'agent name', 'Liczba chłopców', 'Zamówienie główne', 'Rezerwacja wstępna',
  'Prowiant', 'NIP szkoły', 'Formularz', 'Email agenta', 'Liczba dziewczynek', 'Termin Od', 'Miasto szkoły',
  'Nazwa szkoły', 'Liczba kierowców', 'PRO FORMA termin', 'season number', 'Zamówienia powiązane', 'Bez fotografii',
  'Zajęcia', 'Ilość miejsc', 'Zajęcia linowe', 'Województwo szkoły', 'mail nauczyciele punkt 8', 'Specjalna dieta - ZS',
  'Czy kierowca pozostaje w ośrodku', 'Wycieczka edukacyjna', 'Bez dyrektora', 'Uwagi dotyczące agenta',
  'mail nauczyciele wycieczka', 'Udział w zajęciach kajakarskich', 'Wymaga rekalkulacji', 'Specjalna dieta informacje - ZS',
  'Zakwaterowanie dla kierowcy', 'Liczba darmowych opiekunów (mężczyzn)', 'Liczba płatnych opiekunów (mężczyzn)',
  'Odległość od szkoły do ośrodka [m]', 'mail nauczyciele koordynator', 'mail nauczyciele zakwaterowanie',
  'Stałe wartości brutto za każdego opiekuna/uczestnika', 'Liczba darmowych opiekunów (kobiet)',
  'Dodatkowy Nr telefonu opiekuna', 'Liczba płatnych opiekunów (kobiet)', 'Imię osoby reprezentującej szkołę w kontaktach z biurem',
  'Nr. telefonu osoby reprezentującej szkołę w kontaktach z biurem', 'Dodatkowe informacje o uczestnikach',
  'Ilość uczestników w grze paintballowej', 'Nazwisko osoby reprezentującej szkołę w kontaktach z biurem',
  'Stała wartość brutto za każdego opiekuna', 'Stała wartość brutto za każdego uczestnika', 'Opis sezonu',
  '​Dodatkowe informacje na temat ilości klas i ilość osób w nich', 'Zrabatowana wartość brutto za każdego uczestnika',
  'E-mail osoby reprezentującej szkołę w kontaktach z biurem', 'Nazwa promocji zrabatowanej wartości brutto za każdego uczestnika'
];

const zsFieldsToFilter = [
  'Turnus', 'Dieta specjalna', 'Pokój', 'Impreza', 'Moduł', 'Parafia', 'Sezon', 'Przyjaciele', 'Opiekun', 'Rodzeństwo',
  'Zamawiający', 'agent name', 'Zamówienie głowne', 'Formularz', 'Uczestnik', 'Rozmiar koszulki', 'PRO FORMA termin',
  'season number', 'Zamówienia powiązane', 'Lista ID historycznych zamówień powiązanych z tym uczestnikiem', 'Uczestnik miejscowość',
  'Dieta uczestnika', 'Uczestnik nazwa', 'Numer karty rodziny', 'Zachowanie uczestnika', 'Uczestnik kod pocztowy',
  'Rodzaj promocji dla przyjaciół', 'Uczestnik adres ulicy', 'Uczestnika nazwa', 'Wymaga rekalkulacji'
];

function Row(props) {
  const { row, identifier } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell align="left">{formatDateTime(row.created_at)}</TableCell>
        <TableCell align="left">{row.pl_type_name}</TableCell>
        <TableCell align="left">{row.username}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="h6" gutterBottom component="div">
                Historia
              </Typography>
              <Card>
                <CardContent>
                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell align="left">Nazwa pola</TableCell>
                          <TableCell align="left">Przed</TableCell>
                          <TableCell align="left">Po</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {Object.keys(row.json_message).map(key => {
                          let str = row.json_message[key];

                          const name = str.slice(0, str.indexOf(':'));
                          str = str.replace(`${name}:`, '');
                          let valueBefore = '';
                          let valueAfter = '';

                          if (str.indexOf('->') !== -1) {
                            valueBefore = str.slice(0, str.indexOf('->'));
                            valueAfter = str.slice(str.indexOf('->') + 2);
                          } else {
                            valueAfter = str;
                          }

                          if (row.pl_type_name == 'Utworzenie') {
                            if (identifier.startsWith('ol/Lato') && obozyFieldsToFilter.includes(name)) {

                              return;
                            } else if (identifier.startsWith('zs/') && zsFieldsToFilter.includes(name)) {
                              return;
                            }
                          }

                          return <TableRow key={key}>
                            <TableCell align="left" sx={{ whiteSpace: 'pre-line' }}>{name}</TableCell>
                            <TableCell align="left" sx={{ whiteSpace: 'pre-line' }}>{valueBefore}</TableCell>
                            <TableCell align="left" sx={{ whiteSpace: 'pre-line' }}>{valueAfter}</TableCell>
                          </TableRow>;
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </CardContent>
              </Card>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

const ChangeHistory = () => {
  const { order } = useSelector(state => state.orderData);

  return (
    <Box display="flex" flexDirection="column" mt={1}>
      <Card>
        <CardContent>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell />
                  <TableCell align="left">Data</TableCell>
                  <TableCell align="left">Rodzaj operacji</TableCell>
                  <TableCell align="left">Użytkownik</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {order.history_list.map(row => (
                  <Row key={row.id} row={row} identifier={order.identifier} />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    </Box>
  );
};


export default ChangeHistory;
